import { SearchMessagesParams } from './api/hooks/useQuerySearchMessages'

export const chatKeys = {
	all: ['chat'] as const,
	rooms: (filters?: Record<string, unknown>) =>
		filters
			? (['chat', 'rooms', filters] as const)
			: (['chat', 'rooms'] as const),
	room: (id: string) => ['chat', 'room', id] as const,
	unreadCount: () => ['chat', 'unread-count'] as const,
	bannedRooms: (filters?: Record<string, unknown>) =>
		filters
			? (['chat', 'rooms', 'banned', filters] as const)
			: (['chat', 'rooms', 'banned'] as const),
	closedRooms: (filters?: Record<string, unknown>) =>
		filters
			? (['chat', 'rooms', 'closed', filters] as const)
			: (['chat', 'rooms', 'closed'] as const),
	messages: (roomId: string, filters?: Record<string, unknown>) =>
		filters
			? (['chat', 'messages', roomId, filters] as const)
			: (['chat', 'messages', roomId] as const),
	tags: () => ['chat', 'tags'] as const,
	quickResponses: () => ['chat', 'quick-responses'] as const,
	settings: () => ['chat', 'settings'] as const,
	quota: () => ['chat', 'quota'] as const,
	analytics: (params?: Record<string, unknown>) =>
		params
			? (['chat', 'analytics', params] as const)
			: (['chat', 'analytics'] as const),
	stickerPackages: () => ['chat', 'sticker-packages'] as const,
	pinnedMessages: (roomId: string) =>
		['chat', 'pinned-messages', roomId] as const,
	searchMessages: (params?: SearchMessagesParams) =>
		params
			? (['chat', 'search', params] as const)
			: (['chat', 'search'] as const),
	aiDraft: (roomId: string) => ['chat', 'ai-draft', roomId] as const,
	aiSetting: () => ['chat', 'ai-setting'] as const,
	aiPromptCases: () => ['chat', 'ai-prompt-cases'] as const,
	adminTasks: (roomId: string) => ['chat', 'admin-tasks', roomId] as const,
}
